import { H36_500 } from 'commonStyled'
import styled from 'styled-components'

export const Timer = styled.p`
  ${H36_500}
  color: ${(props) => props.theme.primary.default};
`
